import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { signInRedirectLocalStorageKey } from "shared/const";
import { logger } from "shared/utils/logger";

/** @public */
export const Route = createFileRoute("/account/callback")({
    component: () => {
        const auth = useAuth();
        const navigate = useNavigate();

        useEffect(() => {
            if (auth.isLoading) return;
            const redirectUrl = localStorage.getItem(signInRedirectLocalStorageKey);
            if (!!redirectUrl) window.location.replace(redirectUrl);
            else navigate({ to: "/" }).catch(logger.error);
        }, [auth.isLoading]);
    },
});
